import { useMutation } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { ChangeClientStatusRequest } from '@/types/clientDetailsApiTypes';

export type ChangeClientStatusMutationVariables = ChangeClientStatusRequest & { targetClientId?: number };

export const useChangeClientStatusMutation = () => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromUrl = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: changeClientStatus } = useFetch<ChangeClientStatusRequest, void>();

  return useMutation({
    mutationFn: (data: ChangeClientStatusMutationVariables) => {
      const { targetClientId: explicitClientId, ...body } = data;
      const clientIdForRequest = explicitClientId ?? clientIdFromUrl;
      return changeClientStatus(`/api/clients/${clientIdForRequest}/change-status`, {
        method: 'POST',
        body,
      });
    },
  });
};
